import clsx from 'clsx';
import {Trans} from '@common/i18n/trans';
import {useTrans} from '@common/i18n/use-trans';
import {DocHeading} from '@app/docs/extract-doc-headings';

interface PublicDocsTocProps {
  headings: DocHeading[];
}

export function PublicDocsToc({headings}: PublicDocsTocProps) {
  const {trans} = useTrans();
  if (headings.length === 0) {
    return null;
  }

  return (
    <nav aria-label={trans({message: 'On this page'})}>
      <p className="mb-12 text-sm font-semibold">
        <Trans message="On this page" />
      </p>
      <ul className="flex flex-col gap-6 border-l border-divider">
        {headings.map(heading => (
          <li key={heading.id}>
            <a
              href={`#${heading.id}`}
              className={clsx(
                'block border-l-2 border-transparent py-2 text-sm text-muted hover:text-main',
                heading.level === 2 ? 'pl-12' : 'pl-20',
              )}
              onClick={e => {
                e.preventDefault();
                document
                  .getElementById(heading.id)
                  ?.scrollIntoView({behavior: 'smooth'});
                window.history.replaceState(null, '', `#${heading.id}`);
              }}
            >
              {heading.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
